module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.internalOpen),
      callback: function($$v) {
        _vm.internalOpen = $$v
      },
      expression: "internalOpen"
    }
  }, [_c('v-card', [(_vm.rawHtml) ? _c('v-card-text', {
    staticClass: "text-md-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _c('v-card-text', {
    staticClass: "text-md-center"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286892de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMainDialog.vue
// module id = 972
// module chunks = 1